import { motion } from 'framer-motion';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

function EmployeeGrowthChart({ employees = [] }) {
  // Generate growth data over the last 6 months
  const generateGrowthData = () => {
    const months = [];
    const now = new Date();
    
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthName = date.toLocaleDateString('en-US', { month: 'short' });
      
      // Simulate growth - in real app, this would come from actual data
      const baseCount = Math.max(0, employees.length - (5 - i) * 2);
      months.push({
        month: monthName,
        employees: baseCount + Math.floor(Math.random() * 3),
      });
    }
    
    return months;
  };

  const data = generateGrowthData();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.3 }}
      className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700"
    >
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Employee Growth
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" className="dark:stroke-gray-700" />
          <XAxis 
            dataKey="month" 
            stroke="#6b7280"
            className="dark:text-gray-400"
          />
          <YAxis 
            stroke="#6b7280"
            className="dark:text-gray-400"
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--tooltip-bg, #fff)',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              color: '#1f2937',
            }}
            labelStyle={{ color: '#1f2937' }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="employees"
            stroke="#3b82f6"
            strokeWidth={2}
            dot={{ fill: '#3b82f6', r: 4 }}
            activeDot={{ r: 6 }}
            name="Total Employees"
          />
        </LineChart>
      </ResponsiveContainer>
    </motion.div>
  );
}

export default EmployeeGrowthChart;
